module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.cotiaciones), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('div', {
      staticClass: "image-table"
    }, [(data.img) ? _c('img', {
      attrs: {
        "src": data.img,
        "alt": "",
        "width": "180px",
        "height": "260px"
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/images/image-package.png"),
        "alt": "",
        "width": "180px",
        "height": "260px"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.title))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_c('a', {
      attrs: {
        "href": data.url,
        "target": "_blank"
      }
    }, [_vm._v("url")])])])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPedidos
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f5863b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-user/CotizacionComponent.vue
// module id = 1845
// module chunks = 1